import { createStyles, Theme } from '@mui/material';

const styles = (theme: Theme) => createStyles({
  root: {},
});

export default styles;
